//Global decoder so we don't recreate it each time.
const decoder = document.createElement('textarea');

export function decodeHtml(html: string): string {
    decoder.innerHTML = html;
    return decoder.value;
}
